// extracted by mini-css-extract-plugin
export default {"number":"azs8D","hyphen":"J9M6l"};